import { endOfDay, startOfDay } from "date-fns";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { threeDepartmentQueryKeys } from "modules/ThreeDepartmentDashboard/queryKeys";
import { THREE_DEPARTMENT_STORAGE_KEYS } from "modules/ThreeDepartmentDashboard/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";
import { addDaysToDate, toDate } from "utils/dateHelperFunctions";

import type { DealerLocation } from "models";
import type { ThreeDepartmentFilters } from "modules/ThreeDepartmentDashboard/queryKeys";

const getDefaultThreeDepartmentFilters = (selectedLocation?: DealerLocation | null) => {
  const todaysDate = startOfDay(new Date());

  return {
    dealer_location_id: selectedLocation?.id ?? null,
    date_from: toDate(getPreference(THREE_DEPARTMENT_STORAGE_KEYS.DateFromPreference, todaysDate)),
    date_to: toDate(getPreference(THREE_DEPARTMENT_STORAGE_KEYS.DateToPreference, endOfDay(addDaysToDate(todaysDate, 7)))),
    not_checked_by: getPreference(THREE_DEPARTMENT_STORAGE_KEYS.NotCheckedByPreference, null),
    page: 1,
    page_size: getPreference(THREE_DEPARTMENT_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25)
  };
};

export const useThreeDepartmentFilters = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({
    queryKey: threeDepartmentQueryKeys.filters,
    initialData: getDefaultThreeDepartmentFilters(selectedLocation)
  }).data;
};

export const setThreeDepartmentFilters = (newFilters: ThreeDepartmentFilters) => {
  setPreference(THREE_DEPARTMENT_STORAGE_KEYS.DateFromPreference, newFilters.date_from);
  setPreference(THREE_DEPARTMENT_STORAGE_KEYS.DateToPreference, newFilters.date_to);
  setPreference(THREE_DEPARTMENT_STORAGE_KEYS.NotCheckedByPreference, newFilters.not_checked_by);
  setPreference(THREE_DEPARTMENT_STORAGE_KEYS.PageSizePreference, newFilters.page_size);

  typedQueryClient.setQueryData(threeDepartmentQueryKeys.filters, newFilters);
};
